<ng-container *ngIf="clothing$ | async as clothing">
  <div class="full-width flex justify-between p-3 bg-gray-400 items-center">
    <div>
      <app-main-button (click)="navigateBack()">Zurück</app-main-button>
    </div>
    <div class="flex items-center space-x-3">
      <ng-container *ngIf="!editMode; else editModeButton">
        <app-main-button (click)="switchEditMode()">
          <span nz-icon nzType="edit"></span>
          Bearbeiten
        </app-main-button>
      </ng-container>
      <ng-template #editModeButton>
        <app-main-button>
          <span nz-icon nzType="save"></span>
          Speichern
        </app-main-button>
      </ng-template>
      <ng-container *ngIf="!editMode; else editModeLockerButton">
        <a nz-dropdown [nzDropdownMenu]="menu">
          <app-main-button type="secondary"
            >Kleideraktionen <span nz-icon nzType="down"></span
          ></app-main-button>
        </a>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <ng-container>
              <li
                *ngIf="clothing.status !== 4"
                (click)="withdrawClothing()"
                nz-menu-item
              >
                <span nz-icon nzType="arrow-left"></span> Kleiderrücknahme
              </li>
              <li
                *ngIf="
                  !clothing.personId &&
                  clothing.status !== 2 &&
                  clothing.status !== 5
                "
                (click)="onAssignClick()"
                nz-menu-item
              >
                <span nz-icon nzType="arrow-right"></span> Kleiderzuweisung
              </li>
              <li
                *ngIf="clothing.status !== 2 && clothing.status !== 5"
                nz-menu-item
                (click)="tagAsDamaged()"
              >
                <span nz-icon nzType="warning"></span> Beschädigt
              </li>
              <li
                *ngIf="clothing.status !== 5"
                nz-menu-item
                (click)="tagForLaundering()"
              >
                <span nz-icon nzType="clear"></span> Zum waschen
              </li>
            </ng-container>
          </ul>
        </nz-dropdown-menu>
      </ng-container>

      <ng-template #editModeLockerButton>
        <app-main-button (click)="onDeleteClothingClick()" type="danger">
          <span nz-icon nzType="delete"></span>
          Löschen
        </app-main-button>
        <app-main-button type="danger" (click)="switchEditMode()">
          <span nz-icon nzType="close" nzTheme="outline"></span>
          Abbrechen
        </app-main-button>
      </ng-template>
    </div>
  </div>
</ng-container>

<div class="p-6 bg-white">
  <ng-container *ngIf="clothing$ | async as clothing; else loading">
    <div class="flex justify-between w-full pb-20">
      <div class="text-3xl text-blue-900">Kleiderinformationen</div>
    </div>

    <ng-container>
      <form [formGroup]="validateLockerForm">
        <div
          class="pb-5 grid grid-cols-12 grid-rows-3 gap-5"
          [ngClass]="{ 'readonly-select': !editMode }"
        >
          <app-form-input
            label="Bezeichnung"
            attribute="bezeichnung"
            [readOnly]="true"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          ></app-form-input>

          <app-form-select
            label="Größe"
            attribute="kleidergroesse"
            [selectOptions]="selectSizes"
            [readOnly]="!editMode"
            valueKey="codenr"
            labelKey="text"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-select>

          <app-form-select
            label="Status"
            attribute="status"
            [selectOptions]="selectStatus"
            [readOnly]="true"
            valueKey="valueKey"
            labelKey="labelKey"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-select>

          <app-form-select
            label="Geschlecht"
            attribute="geschlecht"
            [selectOptions]="selectGender"
            [readOnly]="true"
            valueKey="valueKey"
            labelKey="labelKey"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-select>

          <app-form-input
            label="Firma"
            attribute="firma"
            [readOnly]="true"
            subformGroup="optionalFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-input>

          <app-form-input
            label="Barcode"
            attribute="inventar"
            [readOnly]="true"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-input>

          <ng-container *ngIf="clothing.status === 1">
            <app-form-input
              subformGroup="optionalFields"
              [readOnly]="true"
              attribute="person"
              label="Person"
              class="sm: col-span-12 md:col-span-12 xl:col-span-6"
            ></app-form-input>
          </ng-container>
        </div>
        <div
          class="grid grid-cols-12 gap-5"
          [ngClass]="{ 'readonly-select': !editMode }"
        >
          <app-form-textarea
            label="Bemerkung"
            attribute="bemerkung"
            [readOnly]="!editMode"
            subformGroup="optionalFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
            placeholder="Schreiben Sie hier einen Kommentar"
          ></app-form-textarea>
        </div>
      </form>
      <div class="pr-10 mt-10">
        <nz-collapse nzGhost>
          <nz-collapse-panel
            [nzHeader]="historyHeader"
            (nzActiveChange)="getClothingHistory($event)"
          >
            <nz-spin [nzSpinning]="isLoadingHistory">
              <div class="pt-10 h-96 overflow-y-auto overflow-x-hidden">
                <nz-timeline nzMode="alternate">
                  @for (event of clothingHistory; track $index) {
                    <nz-timeline-item
                      [nzColor]="setHistoryColor(event.event_typ)"
                    >
                      <p>Am {{ formatDate(event.datum) }}</p>
                      <p>
                        {{ event.beschreibung }}
                      </p>
                      <ng-container *ngIf="event.person">
                        <p>
                          Betroffene Person:
                          {{ event.person?.vorname }}
                          {{ event.person?.name }}
                        </p>
                      </ng-container>
                    </nz-timeline-item>
                  }
                </nz-timeline>
              </div>
            </nz-spin>
          </nz-collapse-panel>
        </nz-collapse>
        <ng-template #historyHeader>
          <p class="text-2xl text-blue-900">Kleidungshistorie</p>
        </ng-template>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #loading>
    <div class="grid grid-cols-1 space-y-4">
      <p class="flex justify-center text-gray-600">
        Lade Kleiderinformationen...
      </p>
      <nz-spin class="flex justify-center" nzSimple></nz-spin>
    </div>
  </ng-template>
</div>

<nz-modal
  [nzFooter]="modalFooter"
  [(nzVisible)]="modalIsVisible"
  nzTitle="Kleiderzuweisung"
  (nzOnCancel)="handleCancel()"
>
  <ng-container *nzModalContent>
    <p class="pb-5 text-lg font-medium">Person zum Zuweisen auswählen</p>

    <div class="grid grid-cols-1 gap-5 pb-5">
      <div class="relative">
        <nz-input-group nzSize="large" [nzPrefix]="prefixTemplateUser">
          <input
            placeholder="Hier Name eingeben"
            nz-input
            [(ngModel)]="searchTerm"
            [nzAutocomplete]="auto"
            (input)="onInput()"
            class="w-full"
          />
          <nz-autocomplete #auto>
            <nz-auto-option
              *ngFor="let person of searchedPersons$ | async; let i = index"
              [nzValue]="person.id"
              [nzLabel]="person.vorname + ' ' + person.name"
            >
              <div class="flex justify-between items-center w-full">
                <span>{{ person.vorname }} {{ person.name }}</span>
                <span class="text-gray-500 text-sm">
                  (Gruppe: {{ getPersonGroup(person) }})
                </span>
              </div>
            </nz-auto-option>
          </nz-autocomplete>
        </nz-input-group>

        <nz-spin
          *ngIf="isLoading"
          nzSimple
          class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-10"
        ></nz-spin>

        <ng-template #prefixTemplateUser>
          <span nz-icon nzType="user"></span>
        </ng-template>
      </div>

      <div>
        <nz-range-picker
          class="w-full"
          nzSize="large"
          nzFormat="dd/MM/yyyy"
          [(ngModel)]="date"
        ></nz-range-picker>
      </div>
    </div>
  </ng-container>
</nz-modal>

<ng-template #modalFooter>
  <div class="flex justify-end">
    <app-main-button (click)="assignClothing()"
      >Kleidung zuweisen
    </app-main-button>
    <app-main-button type="danger" (click)="handleCancel()"
      >Abbrechen
    </app-main-button>
  </div>
</ng-template>
